import { render, staticRenderFns } from "./tv-mails-form.vue?vue&type=template&id=04142ae6&"
import script from "./tv-mails-form.vue?vue&type=script&lang=ts&"
export * from "./tv-mails-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports